import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormInput } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-left: 1rem;
  height: 1.6rem;
  width: 1.6rem;
`;

export const StyledErrorIcon = styled(StyledFontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.error.main};
`;

export const StyledIconGroupWrapper = styled.div`
  align-items: center;
  display: flex;
  margin: 0;
`;

export const StyledFormInput = styled(FormInput)`
  letter-spacing: 0.1rem;
`;
